import { FC } from "react";

import { MDSHorizontalDividerProps } from "./horizontal-divider.types";
import { StyledHorizontalDivider } from "./horizontal-divider.styles";

export const MDSHorizontalDivider: FC<MDSHorizontalDividerProps> = ({ className }) => {
  return <StyledHorizontalDivider className={className} />;
};
